import type { QuizStep } from '../../types';

interface Props {
  step: QuizStep;
}

export function InfoStep({ step }: Props) {
  return (
    <div className="py-6 text-center">
      {step.subtitle && (
        <p className="text-base text-muted-foreground">{step.subtitle}</p>
      )}
    </div>
  );
}
